import type {
  LastDoneView,
  Page,
  RecordLastDoneInput,
  ServiceRecordListQuery,
  ServiceRecordView,
  TruckServiceItemListQuery,
  TruckServiceItemView,
  TruckServiceOverrideInput,
  TruckServiceOverrideView,
} from '@chukua/common';
import { api } from '../../../../shared/shared.api';
import { toListParams } from '../../../../shared/policies/list-params';

export type { LastDoneView, ServiceRecordView, TruckServiceItemView, TruckServiceOverrideView };

export function listTruckServiceItems(truckId: string, query: TruckServiceItemListQuery): Promise<Page<TruckServiceItemView>> {
  return api<Page<TruckServiceItemView>>(`/trucks/${truckId}/service-items?${toListParams(query)}`);
}

export function listTruckServiceOverrides(truckId: string): Promise<TruckServiceOverrideView[]> {
  return api<TruckServiceOverrideView[]>(`/trucks/${truckId}/service-overrides`);
}

export function setTruckServiceOverride(truckId: string, itemId: string, input: TruckServiceOverrideInput): Promise<TruckServiceOverrideView> {
  return api<TruckServiceOverrideView>(`/trucks/${truckId}/service-overrides/${itemId}`, { method: 'PUT', body: JSON.stringify(input) });
}

export async function removeTruckServiceOverride(truckId: string, itemId: string): Promise<void> {
  await api<void>(`/trucks/${truckId}/service-overrides/${itemId}`, { method: 'DELETE' });
}

export function recordLastDone(truckId: string, itemId: string, input: RecordLastDoneInput): Promise<LastDoneView> {
  return api<LastDoneView>(`/trucks/${truckId}/service-items/${itemId}/last-done`, { method: 'POST', body: JSON.stringify(input) });
}

export function listServiceRecords(truckId: string, query: ServiceRecordListQuery): Promise<Page<ServiceRecordView>> {
  return api<Page<ServiceRecordView>>(`/trucks/${truckId}/service-records?${toListParams(query)}`);
}
